'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _components2 = require('components');

var _utils = require('helpers/utils');

require('./CouponSearchModalView.less');

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    CouponSearchModalView: {
        displayName: 'CouponSearchModalView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Search/CouponSearchModal/default/CouponSearchModalView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var CouponSearchModalView = _wrapComponent('CouponSearchModalView')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(CouponSearchModalView, _Component);

    function CouponSearchModalView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CouponSearchModalView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CouponSearchModalView.__proto__ || (0, _getPrototypeOf2.default)(CouponSearchModalView)).call.apply(_ref, [this].concat(args))), _this), _this.renderVoiceCode = function () {
            if (_this.props.codeSendFor === 'phone') {
                return _react3.default.createElement(_components2.VoiceCode, {
                    login: _this.props.login,
                    source: 'registration',
                    showAlert: _this.showOuterAlert,
                    whiteList: false
                });
            }
            return null;
        }, _this.showOuterAlert = function (alert) {
            // this.setState({outerAlert: alert});
        }, _this.renderTimer = function () {
            return _react3.default.createElement(
                _reactBootstrap.FormGroup,
                null,
                _react3.default.createElement(
                    'div',
                    { className: 'voice_wrap text-center' },
                    _this.props.timeToResentCode > 0 ? _react3.default.createElement(
                        'p',
                        { id: 'voice_call_time_wrap', className: 'active' },
                        _this.props.lang['store.iBonus.modals.resendCodeReRequest'],
                        ' ',
                        _react3.default.createElement(
                            'span',
                            { id: 'voice_call_time active' },
                            _this.props.timeToResentCode
                        ),
                        ' ',
                        _this.props.lang['store.iBonus.modals.resendCodeReRequest.seconds']
                    ) : _react3.default.createElement(
                        _components2.Preloader,
                        { classNames: 'mini_preload', preload: _this.props.preloader },
                        _react3.default.createElement(
                            'a',
                            { id: 'get_voice_call', href: '#', onClick: _this.props.onClickResendCode },
                            _this.props.lang['store.iBonus.modals.resendCode']
                        )
                    )
                )
            );
        }, _this.onClickConfirmOneClick = function (event) {
            event.preventDefault();
            _this.props.onClickConfirmOneClick(event);
        }, _this.showOneClickConfirm = function () {
            if (_this.props.codeSendFor !== '') {
                if (_this.props.codeSendFor === 'email') {
                    var _description = _this.props.lang['store.iBonus.modals.codeEmail'];
                    return _react3.default.createElement(
                        'div',
                        { className: 'bordered' },
                        _react3.default.createElement(
                            _reactBootstrap.FormGroup,
                            null,
                            _description
                        ),
                        _react3.default.createElement(
                            _reactBootstrap.FormGroup,
                            { style: { marginBottom: '0px' } },
                            _react3.default.createElement(
                                _reactBootstrap.ControlLabel,
                                null,
                                _this.props.lang['store.iBonus.modals.enterCodeEmail'],
                                '*'
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-7 text-right no-padding' },
                            _react3.default.createElement(_reactBootstrap.FormControl, {
                                type: (0, _utils.isMobileDevice)() ? "number" : "text",
                                pattern: '\\d*',
                                placeholder: '1234',
                                value: _this.props.emailCode,
                                onChange: function onChange(e) {
                                    if ((0, _utils.validateNumeric)(e.target.value)) {
                                        _this.props.changeField('emailCode')(e);
                                    }
                                }
                            })
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-5 text-right inline_block button_width_100' },
                            _react3.default.createElement(
                                _reactBootstrap.Button,
                                {
                                    type: 'submit',
                                    bsStyle: 'primary',
                                    className: 'form-control',
                                    disabled: _this.props.disabledSubmitOneClick,
                                    onClick: _this.onClickConfirmOneClick
                                },
                                _this.props.lang['store.iBonus.modals.Confirm']
                            )
                        ),
                        _react3.default.createElement(
                            _reactBootstrap.FormGroup,
                            { style: { paddingTop: '26px', marginTop: '20px' } },
                            _this.renderTimer()
                        )
                    );
                }
                var description = _this.props.lang['store.iBonus.modals.codeSms'];
                return _react3.default.createElement(
                    'div',
                    { className: 'bordered' },
                    _react3.default.createElement(
                        _reactBootstrap.FormGroup,
                        null,
                        description
                    ),
                    _react3.default.createElement(
                        _reactBootstrap.FormGroup,
                        { style: { marginBottom: '0px' } },
                        _react3.default.createElement(
                            _reactBootstrap.ControlLabel,
                            null,
                            _this.props.lang['store.iBonus.modals.enterCodeSms'],
                            '*'
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-7 text-right no-padding' },
                        _react3.default.createElement(_reactBootstrap.FormControl, {
                            type: (0, _utils.isMobileDevice)() ? "number" : "text",
                            pattern: '\\d*',
                            placeholder: '1234',
                            value: _this.props.phoneCode,
                            onChange: function onChange(e) {
                                if ((0, _utils.validateNumeric)(e.target.value)) {
                                    _this.props.changeField('phoneCode')(e);
                                }
                            }
                        })
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-5 text-right inline_block button_width_100' },
                        _react3.default.createElement(
                            _reactBootstrap.Button,
                            {
                                type: 'submit',
                                bsStyle: 'primary',
                                className: 'form-control',
                                disabled: _this.props.disabledSubmitOneClick,
                                onClick: _this.onClickConfirmOneClick
                            },
                            _this.props.lang['store.iBonus.modals.Confirm']
                        )
                    ),
                    _react3.default.createElement(
                        _reactBootstrap.FormGroup,
                        { style: { paddingTop: '26px', marginTop: '20px' } },
                        _this.renderVoiceCode()
                    ),
                    _react3.default.createElement(
                        _reactBootstrap.FormGroup,
                        null,
                        _this.renderTimer()
                    )
                );
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CouponSearchModalView, [{
        key: 'render',
        value: function render() {
            var couponsImage = null;
            if (this.props.coupon !== null) {
                couponsImage = _react3.default.createElement('div', { style: { width: '72px', height: '72px', padding: '4px' } });
                if (this.props.coupon.imagePath !== null) {
                    couponsImage = _react3.default.createElement(
                        'div',
                        { className: 'text-center', style: { maxWidth: '72px', maxHeight: '72px', padding: '4px' } },
                        _react3.default.createElement('img', { style: { maxWidth: '68px', maxHeight: '68px', marginLeft: 'auto', marginRight: 'auto' }, src: this.props.coupon.imagePath })
                    );
                }
            }
            return _react3.default.createElement(
                _components2.Preloader,
                { preload: this.props.preload },
                _react3.default.createElement(
                    'section',
                    { id: 'search-coupon-form' },
                    this.props.coupon === null ? _react3.default.createElement(
                        'div',
                        null,
                        _react3.default.createElement(
                            _reactBootstrap.FormGroup,
                            null,
                            _react3.default.createElement(
                                _reactBootstrap.ControlLabel,
                                null,
                                this.props.lang['store.iBonus.modals.token']
                            ),
                            _react3.default.createElement(_reactBootstrap.FormControl, {
                                value: this.props.token,
                                type: 'text',
                                placeholder: '123456',
                                onChange: this.props.onChange
                            })
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-6 col-md-36' },
                                _react3.default.createElement(
                                    _reactBootstrap.FormGroup,
                                    null,
                                    _react3.default.createElement(
                                        _reactBootstrap.Button,
                                        {
                                            type: 'submit',
                                            className: 'form-control',
                                            bsStyle: 'primary',
                                            onClick: this.props.onSubmit
                                        },
                                        'OK'
                                    )
                                )
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-6 col-md-6' },
                                _react3.default.createElement(
                                    _reactBootstrap.FormGroup,
                                    null,
                                    _react3.default.createElement(
                                        _reactBootstrap.Button,
                                        { type: 'submit', bsStyle: 'success', className: 'form-control', onClick: this.props.closeModal },
                                        this.props.lang['store.common.cancel']
                                    )
                                )
                            )
                        )
                    ) : null,
                    this.showOneClickConfirm()
                )
            );
        }
    }]);
    return CouponSearchModalView;
}(_react2.Component), _class.propTypes = {}, _temp2));

exports.default = CouponSearchModalView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/CouponSearchModal/default/CouponSearchModalView.jsx
// module id = 1762
// module chunks = 0